import { Select, SelectOption } from '@lifeomic/chroma-react/components/Select';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  CompositeReportDefinitionSummary,
  ModelUtils,
} from '../../../../AITemplates/models';

const messages = defineMessages({
  label: {
    id: 'CRDSelect.label',
    defaultMessage: 'Select a Composite Report Template',
  },
  noTemplateSectionsSubtitle: {
    id: 'CRDSelect.noTemplateSectionsSubtitle',
    defaultMessage: 'No template sections configured',
  },
});

type CRDSelectProps = {
  crdDurableId?: string;
  setCrdDurableId: (crdDurableId?: string) => void;
  compositeReportDefinitions: CompositeReportDefinitionSummary[];
  hasTemplateSections: (durableId: string) => boolean | undefined;
};

export const CRDSelect: React.FC<CRDSelectProps> = ({
  crdDurableId,
  setCrdDurableId,
  compositeReportDefinitions,
  hasTemplateSections,
}) => {
  const { formatMessage } = useIntl();

  const setCrdFromDurableId = (durableId?: string) => {
    if (durableId) {
      const crd = compositeReportDefinitions.find(
        crd => crd.durableId === durableId,
      );
      setCrdDurableId(crd?.durableId);
    } else {
      setCrdDurableId(undefined);
    }
  };

  return (
    <Select
      label={formatMessage(messages.label)}
      value={crdDurableId ?? ''}
      onChange={value => setCrdFromDurableId(value)}
      fullWidth
    >
      {compositeReportDefinitions.map(crd => {
        const usable = hasTemplateSections(crd.durableId);
        const showSectionWarning = usable === false;
        const subtitle = showSectionWarning
          ? [
              crd.description,
              formatMessage(messages.noTemplateSectionsSubtitle),
            ]
              .filter(Boolean)
              .join(' — ')
          : crd.description;
        return (
          <SelectOption
            key={crd.durableId}
            value={crd.durableId}
            title={ModelUtils.getName(crd)}
            subtitle={subtitle}
          />
        );
      })}
    </Select>
  );
};
